module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_baloon-1a5ad0190313e1e5e8b65db2112690ff.svg";